import Vue from 'vue'
import Router from 'vue-router'


import home from '@/views/Home'
import notFound from '@/views/404.vue'
import menu from '@/views/Menu'
import login from '@/views/Login'

import evasione from '@/views/magazzino/Evasione'
import ricevimento from '@/views/magazzino/Ricevimento'
import scorte from '@/views/magazzino/Scorte'
import ordiniFor from '@/views/magazzino/OrdiniFornitori'
import ubicazioni from '@/views/magazzino/Ubicazioni'
import maniglie from '@/views/magazzino/Maniglie'

import consegne from '@/views/consegne/consegne'

import terzisti from '@/views/terzisti/Terzisti'
import GestioneLotti from "@/views/terzisti/GestioneLotti"

import storage from '@/services/storage.js'

Vue.use(Router)



const routerOptions = [
  {
    path: '/',
    component: home,
    meta: {
      checkAuth: true
    },
    children: [
      {
        path: '/',
        component: menu,
        meta: {
          checkAuth: true
        }
      },
      {
        path: '/ricevimento/:tipo',
        component: ricevimento,
        meta: {
          checkAuth: true
        },
        props: true

      },
      {
        path: '/evasione/:tipo',
        component: evasione,
        meta: {
          checkAuth: true
        },
        props: true

      },

      {
        path: '/consegne/:tipo',
        component: consegne,
        meta: {
          checkAuth: true
        },
        props: true
      },
      {
        path: '/scorte',
        component: scorte,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/ordinifornitori',
        component: ordiniFor,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/ubicazioni',
        component: ubicazioni,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/maniglie',
        component: maniglie,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/terzisti',
        component: terzisti,
        meta: {
          checkAuth: true
        },
      },
      {
        path: '/gestione_lotti',
        component: GestioneLotti,
        meta: {
          checkAuth: true
        },
      },
    ]
  },
  {
    path: '/login',
    component: login,
  },
  {
    name: '404',
    path: '*',
    component: notFound,
    props: false
  }

]




const rou = new Router({
  mode: '',
  routes: routerOptions
})


rou.beforeEach((to, from, next) => {

  // Controllo se è richiesta l'autenticazione
  if (to.meta.checkAuth && !storage.checkAuth()) {

    next({
      path: '/login'
    })

    return

  }
  // Controllo pagina login
  else if (to.path == "/login" && storage.checkAuth()) {

    // Se il login è stato fatto, vado alla pagina di login
    next({
      path: '/login'
    })
    return
  }

  next();

})



export default rou;